// src/services/attendanceService.js
//
// Wraps /api/attendance/* and /api/schedules/* backend calls.
// FULL UPDATED FILE - No functions removed.
import { api } from './api';

export const attendanceService = {
  // --- Attendance Marking (Location-based, no face recognition) ---
  markAttendance: (mode, lat, lng) => {
    const payload = {
      mode: mode,
      latitude: lat,
      longitude: lng
    };
    return api.post('/api/attendance/mark', payload);
  },

  // --- Attendance Records ---
  getByDate: (dateStr, department) => {
    const params = new URLSearchParams();
    if (department) params.append('department', department);
    const qs = params.toString();
    return api.get('/api/attendance/date/' + dateStr + (qs ? '?' + qs : ''));
  },

getToday: (department) => {
    const params = new URLSearchParams();
    if (department) params.append('department', department);
    const qs = params.toString();
    return api.get('/api/attendance/today' + (qs ? '?' + qs : ''));
  },

  // Feature: date-range register (weekly/monthly/yearly/custom filters).
  getRange: (dateFrom, dateTo, department) => {
    const params = new URLSearchParams();
    params.append('date_from', dateFrom);
    params.append('date_to', dateTo);
    if (department) params.append('department', department);
    return api.get('/api/attendance/range?' + params.toString());
  },
  // NEW: Fetch specific status for the employee dashboard
  getTodayStatus: (employeeId) => {
    const today = new Date().toISOString().split('T')[0];
    return api.get('/api/attendance/date/' + today); // Filter check will be on frontend
  },
  getMyStatus: () => api.get('/api/attendance/my-status'),

  getEmployeeHistory: (employeeId, month, year) => {
    const params = new URLSearchParams();
    if (month) params.append('month', month);
    if (year) params.append('year', year);
    const qs = params.toString();
    return api.get('/api/attendance/employee/' + employeeId + (qs ? '?' + qs : ''));
  },

  manualOverride: (employeeId, mode, reason) =>
    api.post('/api/attendance/manual-override', { 
      employee_id: employeeId, 
      mode: mode, 
      reason: reason 
    }),

  markAbsentees: () =>
    api.post('/api/attendance/run-absent-marking', {}),

  // --- Work Schedules Management (Settings & Dashboard) ---
  getSchedules: (department) => {
    const params = new URLSearchParams();
    if (department) params.append('department', department);
    const qs = params.toString();
    return api.get('/api/schedules/' + (qs ? '?' + qs : ''));
  },

  createSchedule: (data) =>
    api.post('/api/schedules/', data),

  updateSchedule: (scheduleId, data) =>
    api.put('/api/schedules/' + scheduleId, data),

  deleteSchedule: (scheduleId) =>
    api.delete('/api/schedules/' + scheduleId),
};